export const getRouting = state => state.routing;
export const getLoading = state => state.routing.loading;
export const getErrors = state => state.routing.errors;
export const getPreviousPage = state => state.routing.previousPage;
export const getCurrentPage = state => state.routing.currentPage;
export const getIsServerRendering = state => state.routing.isServerRendering;
